import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { JwtInterceptor } from '../shared/jwt.interceptor';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MAT_DATE_LOCALE } from '@angular/material/core';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';

// Import containers
import { DefaultFooterComponent, DefaultHeaderComponent, DefaultLayoutComponent } from './containers';

import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  ModalModule,
  UtilitiesModule
} from '@coreui/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { IconModule, IconSetService } from '@coreui/icons-angular';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { AlertsService } from './alerts.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from './services/modal.service';
import { EventsService } from './services/events.service';
import { DatePipe } from '@angular/common';
import { RoomService } from './services/room.service';
import { CourseService } from './services/course.service';
import { UserService } from './services/user.service';
import { CampusService } from './services/campus.service';
import { HostelService } from './services/hostel.service';
import { HostelAllocationService } from './services/hostel-allocation.service';
import { HostelDashboardService } from './services/hostel-dashboard.service';
import { CalendarModule, CalendarDateFormatter, CalendarMomentDateFormatter, DateAdapter, MOMENT } from 'angular-calendar';
import * as moment from 'moment';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import { InfoDialogComponent } from './views/info-dialog/info-dialog.component';
import { ConfirmDialog } from '../shared/dialog.component';
import { MaterialModule } from '../shared/material.module';
import { BatchService } from './services/batch.service';
import { MatTooltipModule } from '@angular/material/tooltip';


const APP_CONTAINERS = [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent
];

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [InfoDialogComponent, AppComponent, ConfirmDialog, ...APP_CONTAINERS,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,

    AvatarModule,
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000, // 15 seconds
      closeButton: false,
      progressBar: false,
    }),
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ModalModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    ReactiveFormsModule,
    NgSelectModule,
    SidebarModule,
    SharedModule,
    MaterialModule,
    TabsModule,
    ListGroupModule,
    ProgressModule,
    BadgeModule,
    ListGroupModule,
    HttpClientModule,
    FormsModule,
    CardModule,
    NgScrollbarModule,
    NgbModule,
    MatTooltipModule,
    CalendarModule.forRoot(
      {
        provide: DateAdapter,
        useFactory: momentAdapterFactory,
      },
      {
        dateFormatter: {
          provide: CalendarDateFormatter,
          useClass: CalendarMomentDateFormatter,
        },
      }
    )
  ],
  providers: [
    { provide: MOMENT, useValue: moment },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,
    AuthGuard,
    DatePipe,
    ModalService,
    RoomService,
    CourseService,
    UserService,
    CampusService,
    HostelService,
    HostelAllocationService,
    HostelDashboardService,
    BatchService,
    AuthService,
    EventsService,
    AlertsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor, // To intercept each http reqeust to the server and add the JWT token to it
      multi: true
    },
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
